<script>
  import MiniCard from './UC-mini-card.svelte'
  
  import { readable } from 'svelte/store'

  // import JsonDebug from './utilities/JsonDebug.svelte'

  export let title = 'College Academic Ranking'
  export let groupCode = 'COM'
  export let itemClasses = ''
  export let isLoading = false
  export let isBusinessUnit = false

  export let dataStore = undefined
  $: dataStoreContents = dataStore ? $dataStore : []

  export let data = undefined
  $: {
    if(data) {
      dataStore = readable(data)
    }
  }

  export let loadingStore = undefined

  let leftCol = []
  let rightCol = []

  function getOrdinalSuffix(i) {
    var j = i % 10,
        k = i % 100
    if (j == 1 && k != 11) {
        return i + "st"
    }
    if (j == 2 && k != 12) {
        return i + "nd"
    }
    if (j == 3 && k != 13) {
        return i + "rd"
    }
    return i + "th"
  }

  function getPrefixedRank(i) {
    if (isBusinessUnit) {
      return 'Business Unit ' + i
    } else {
      return 'College ' + i
    }
  }

  function sortData(data) {
    return data.sort(function(a, b) {return b.OverallScore - a.OverallScore})
  }

  function rankData() {
    if($dataStore.length) {
      $dataStore.forEach((item, index)=> {
        item.position = index + 1
      })
    }
  }

  function anonymizeData(data) {
    // return data;
    return data.map(function(ele) {
      if(ele.GroupCode == groupCode) {
        // flag the school we want to spotlight in the UI
        // ele.GroupShortName = ele.GroupShortName + (ele.isTie ? ' (tie)' : '');
        // ele.GroupName = ele.GroupName + (ele.isTie ? ' (tie)' : '');
        ele.isSpotlighted = true
        
      } else {
        // anonymize all other GroupNames
        ele.isSpotlighted = false
        ele.GroupShortName = getPrefixedRank(ele.rank)
        ele.GroupName = ele.GroupShortName
      }

      return ele
    });
  }

  function partitionData() {
    if($dataStore && $dataStore.length > 0) {
      let tmpData = Array.from($dataStore)

      rightCol = [];
      leftCol = [];

      // if we have an odd number, we'll stack the left column with the extra item
      let leftColLength = Math.floor(tmpData.length / 2) + (tmpData.length % 2);
      let rightColLength = tmpData.length -  leftColLength;

      for (let step = 0; step < rightColLength; step++) {
        // let's slam through this loop real quick and make ourselves a right column
        rightCol.push(tmpData.pop());
      }

      // what remains will go into our left column
      leftCol = tmpData;

      // reverse the right column
      rightCol.reverse();
    }
  }

  function processData() {
    rankData()
    partitionData()
  }

  $: processData($dataStore)
</script>


{ #if loadingStore && $loadingStore }
  loading...
{ :else }
  <div class="leaderboard" aria-live="polite" aria-busy="{ isLoading }">
    <h3>{ title }</h3> 
    <div class="colum-wrapper">
      <div class="left-col">
        {#each leftCol as {OverallScore, ConditionalGroupName, GroupName, GroupCode, OverallScoreLabel, position }, i }
          <div class="leaderboard-item { itemClasses }">
            <MiniCard value="{(OverallScore * 1).toFixed(1)}" name="{ GroupName }" { position } />
          </div>
        {/each}
        </div>
    
        <div class="right-col">
          {#each rightCol as {OverallScore, ConditionalGroupName, GroupName, GroupCode, OverallScoreLabel, position }, i }
            <div class="leaderboard-item { itemClasses }">
              <MiniCard value="{(OverallScore * 1).toFixed(1)}" name="{ GroupName }" { position } />
            </div>
          {/each}
        </div>
    </div>
  </div>
{ /if }

<style>
  .leaderboard h3{
    font-size: 3rem;
    font-weight: 600;
    position: relative;
    color: #e00122;
    margin: 0 0 1.5rem;
  }
  .leaderboard .colum-wrapper {
    display: flex;
    flex-flow: row wrap;
    gap: 0 20px;
  }

  .left-col, .right-col {
    width: 100%;
    flex-grow: 1;
    flex-basis: 45%;
    min-width: 28.1rem;
  }

  .leaderboard-item {
    margin-bottom: 20px;
  }
</style>